import React, { useEffect } from "react";
import { Popper, Box, Typography } from "@mui/material";
import { useMessageClasses } from "./Message.style.js";
var MessageOrientation = /* @__PURE__ */ ((MessageOrientation2) => {
  MessageOrientation2["Inline"] = "Inline";
  MessageOrientation2["Floating"] = "Floating";
  return MessageOrientation2;
})(MessageOrientation || {});
var MessageType = /* @__PURE__ */ ((MessageType2) => {
  MessageType2["Info"] = "Info";
  MessageType2["Success"] = "Success";
  MessageType2["Error"] = "Error";
  MessageType2["Warning"] = "Warning";
  return MessageType2;
})(MessageType || {});
function MessageInner({
  message,
  className,
  variant,
  messageOrientation = "Inline",
  messageType = "Info",
  dataTestId
}) {
  const { classes, cx } = useMessageClasses();
  return message === null || message === void 0 ? null : /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.message, className, {
        [classes.floatingMessage]: messageOrientation === "Floating",
        [classes.floatingErrorMessage]: messageOrientation === "Floating" && messageType === "Error",
        [classes.floatingSuccessMessage]: messageOrientation === "Floating" && messageType === "Success",
        [classes.floatingWarningMessage]: messageOrientation === "Floating" && messageType === "Warning",
        [classes.floatingInfoMessage]: messageOrientation === "Floating" && messageType === "Info",
        [classes.errorMessage]: messageType === "Error",
        [classes.successMessage]: messageType === "Success",
        [classes.warningMessage]: messageType === "Warning",
        [classes.infoMessage]: messageType === "Info"
        /* Info */
      })
    },
    /* @__PURE__ */ React.createElement(Typography, { "data-testid": dataTestId ?? "message", variant: variant ?? "body1" }, message)
  );
}
function Message({ hideMessage, messageOrientation = "Inline", containerRef, ...props }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const visible = !hideMessage && Boolean(props.message);
  const showMessagePopover = () => {
    setAnchorEl(containerRef?.current);
  };
  const hideMessagePopover = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    if (visible) {
      showMessagePopover();
    } else {
      hideMessagePopover();
    }
  }, [visible]);
  const messageInnerProps = { ...props, messageOrientation };
  return messageOrientation === "Floating" ? /* @__PURE__ */ React.createElement(Popper, { open: visible, anchorEl, placement: "bottom-start" }, /* @__PURE__ */ React.createElement(MessageInner, { ...messageInnerProps })) : /* @__PURE__ */ React.createElement(MessageInner, { ...messageInnerProps });
}
export {
  Message,
  MessageOrientation,
  MessageType
};
//# sourceMappingURL=Message.js.map
